
export const common = {
  // Navigation
  home: 'Accueil',
  services: 'Services',
  about: 'À Propos',
  gallery: 'Galerie',
  contact: 'Contact',
  reserve: 'Réserver',
  
  // Buttons
  bookNow: 'Réservez Maintenant',
  learnMore: 'En savoir plus',
  whatsapp: 'WhatsApp',
  close: 'Fermer',
  
  // Hero Section
  heroTitle: 'Voyagez avec',
  heroTitleHighlight: 'Élégance',
  heroDescription: 'Découvrez le Maroc et le Canada autrement avec notre service de transport premium. Confort, sécurité et hospitalité authentique.',
  
  // Services
  servicesTitle: 'Nos Services Premium',
  servicesDescription: 'Une gamme complète de services de transport touristique pour répondre à tous vos besoins de voyage, du transfert simple aux circuits les plus exclusifs.',
  
  // About
  aboutTitle: 'Notre Histoire',
  aboutDescription1: 'Depuis plus de 10 ans, nous offrons une expérience de transport touristique exceptionnelle au Maroc et au Canada. Notre passion pour l\'hospitalité marocaine et notre expertise du terrain nous permettent de créer des voyages inoubliables.',
  aboutDescription2: 'Que vous soyez un voyageur d\'affaires, une famille en vacances ou un groupe d\'amis en quête d\'aventure, nous mettons notre savoir-faire à votre service pour que chaque kilomètre soit un plaisir.',
  
  // Values
  security: 'Sécurité',
  securityDesc: 'Véhicules entretenus et chauffeurs certifiés pour votre tranquillité d\'esprit.',
  punctuality: 'Ponctualité',
  punctualityDesc: 'Respect des horaires et des engagements pour un service fiable.',
  hospitality: 'Hospitalité',
  hospitalityDesc: 'Accueil chaleureux et service personnalisé dans la tradition marocaine.',
  excellence: 'Excellence',
  excellenceDesc: 'Recherche constante de la perfection dans chaque détail de nos services.',
  
  // Testimonials
  testimonialsTitle: 'Témoignages Clients',
  testimonialsDescription: 'Découvrez ce que nos clients disent de leur expérience avec notre service de transport premium.',
  satisfiedClients: 'Clients Satisfaits',
  destinations: 'Destinations',
  customerService: 'Service Client',
  
  // Reservation
  reservationTitle: 'Réservez Votre Transport',
  reservationDescription: 'Remplissez le formulaire ci-dessous pour obtenir un devis personnalisé ou réserver directement votre service de transport premium.',
  fullName: 'Nom complet',
  email: 'Email',
  phone: 'Téléphone',
  desiredService: 'Service souhaité',
  selectService: 'Sélectionnez un service',
  departureDate: 'Date de départ',
  departureTime: 'Heure de départ',
  passengers: 'Passagers',
  passenger: 'passager',
  departureLocation: 'Lieu de départ',
  destination: 'Destination',
  message: 'Message ou demandes spéciales',
  messageDescription: 'Décrivez vos besoins spécifiques, préférences ou questions...',
  sendRequest: 'Envoyer la demande',
  sending: 'Envoi en cours...',
  directContact: 'Contact Direct',
  availability: 'Disponibilité',
  quickResponse: 'Réponse Rapide',
  quickResponseDescription: 'Nous nous engageons à vous répondre dans les plus brefs délais :',
  whatsappResponse: 'WhatsApp : Réponse immédiate',
  emailResponse: 'Email : Sous 2 heures',
  freeQuote: 'Devis gratuit et sans engagement',
  
  // Contact
  contactTitle: 'Contactez-Nous',
  contactDescription: 'Notre équipe est à votre disposition pour répondre à toutes vos questions et vous accompagner dans l\'organisation de vos déplacements.',
  sendMessage: 'Envoyez-nous un message',
  subject: 'Sujet',
  selectSubject: 'Sélectionnez un sujet',
  quoteRequest: 'Demande de devis',
  serviceInfo: 'Information sur nos services',
  complaint: 'Réclamation',
  partnership: 'Proposition de partenariat',
  other: 'Autre',
  messageRequired: 'Message',
  messageContactDescription: 'Décrivez votre demande en détail...',
  sendMessageBtn: 'Envoyer le message',
  ourCoordinates: 'Nos Coordonnées',
  address: 'Adresse',
  telephone: 'Téléphone',
  hours: 'Horaires',
  officeHours: 'Bureau : 8h - 20h',
  followUs: 'Suivez-nous',
  ourLocation: 'Notre Localisation',
  
  // Form Messages
  successMessage: 'Votre demande a été envoyée avec succès ! Nous vous contacterons rapidement.',
  successContactMessage: 'Votre message a été envoyé avec succès ! Nous vous répondrons rapidement.',
  errorMessage: 'Une erreur s\'est produite. Veuillez réessayer ou nous contacter directement.',
  charactersLimit: 'caractères',
  
  // Footer
  footerDescription: 'Votre partenaire de confiance pour un transport touristique de luxe au Maroc et au Canada. Découvrez nos destinations avec élégance et confort.',
  ourServices: 'Nos Services',
  copyright: '© 2024 HAFY TOURS. Tous droits réservés.',
  poweredBy: 'Powered by Readdy',
  
  // Common
  yearsExperience: 'Années d\'expérience',
  includedInService: 'Inclus dans le service',
  reserveThisService: 'Réserver ce service',
  chatOnWhatsApp: 'Discuter sur WhatsApp',
  notAvailableYet: 'Pas encore disponible pour le moment',
  required: '*',
  placeholderName: 'Votre nom complet',
  placeholderEmail: 'votre@email.com',
  placeholderPhone: '+212 6XX XXX XXX',
  placeholderDeparture: 'Aéroport, hôtel, adresse...',
  placeholderDestination: 'Ville, site touristique...'
};
